export default {
    jsonToDomSetter: {
        title: 'JSON Selector',
        expression: 'Expression',
        expressionTip: 'Please select a node below',
        arrayInputKey: 'Input',
        confirm: 'Confirm',
        cancel: 'Cancel',

    }
}